import { render, staticRenderFns } from "./TimelineBackgroundCanvas.vue?vue&type=template&id=4ff9a9d7&"
import script from "./TimelineBackgroundCanvas.vue?vue&type=script&lang=js&"
export * from "./TimelineBackgroundCanvas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports